module.exports = __webpack_public_path__ + "1d8e9a6ab2c4fa321e2d337fe36f8fa0.png";